import { all } from 'redux-saga/effects';

//PIPELINE
import initializeUrl from './initializeUrl';
import initializeEreader from './initializeEreader';
import bindVitalSourceEvents from './bindVitalSourceEvents';

//OTHER
import getVsMarkers from './getVsMarkers';

//HIGHLIGHTS
import highlight from './Highlight';

//NOTES
import note from './Note';

//BOOKMARKS
// import createBookmark from './createBookmark';
// import deleteBookmark from './deleteBookmark';

//NAVIGATION
import navigation from './Navigation';

//NOTEBOOK
import notebook from './Notebook';

//Notifications
import notifications from './Notifications';

//SETTINGS
import settings from './Settings';

//PAGES
import pages from './Pages';


export default function* rootSaga() {
  yield all([
    initializeUrl(),

    //PIPELINE
    initializeEreader(),
    bindVitalSourceEvents(),

    //OTHER
    getVsMarkers(),

    highlight(),
    navigation(),
    note(),
    notebook(),
    notifications(),
    settings(),
    pages()

    // createBookmark(),
    // deleteBookmark(),
  ]);
}
